import { createListenerMiddleware } from '@reduxjs/toolkit';
import { loadConfiguration } from '../reducers/flexConfiguration';
import { setLanguage } from '../reducers/language';

export const languageMiddleware = createListenerMiddleware();

languageMiddleware.startListening({
    actionCreator: loadConfiguration,
    effect: (action, listenerApi) => {
      const language = action.payload?.language || 'es';
      listenerApi.dispatch(setLanguage(language));
    }
});
